import { render, staticRenderFns } from "./SearchHero.vue?vue&type=template&id=35f82d55&"
import script from "./SearchHero.vue?vue&type=script&lang=js&"
export * from "./SearchHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports